export default __webpack_public_path__ + "static/tools-romax-compact-tt-cfe6874cdabc2425e28ed6d50f105349.jpg";